import { HistoryOutlined } from '@ant-design/icons';
import { Typography, Button } from 'antd';
import Tooltip from 'antd/lib/tooltip';
import React, { ReactElement } from 'react';

import classes from './HomeHistoryHeader.module.css';

interface HomeHistoryHeaderProps {
  handleViewHistory?: (e: React.MouseEvent) => void;
  headerTitle?: string;
  resetStylesForCardHeader?: boolean;
  tooltipTitle?: string;
}

function HomeHistoryHeader({
  handleViewHistory,
  headerTitle = 'Readme',
  resetStylesForCardHeader = false,
  tooltipTitle = 'View Readme Version History',
}: HomeHistoryHeaderProps): ReactElement {
  return (
    <div className={resetStylesForCardHeader ? classes.titleFlexRowNoMargin : classes.titleFlexRow}>
      {resetStylesForCardHeader ? <>{headerTitle}</> : <Typography.Text strong>{headerTitle}</Typography.Text>}
      <Tooltip title={tooltipTitle} placement="top">
        <Button type="text" shape="circle" onClick={handleViewHistory} icon={<HistoryOutlined />} />
      </Tooltip>
    </div>
  );
}

export default HomeHistoryHeader;
